import { apiClient, apiGet, apiPost, apiPut, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";
import { buildPaginatedUrl } from "@/lib/api/utils";

const BASE = "/articles";

export const articlesApi = {
  list: (params?: PaginatedParams & { category?: string; author?: string }) => {
    const extraParams: Record<string, string | string[]> = {};
    if (params?.category) extraParams.category = params.category;
    if (params?.author) extraParams.author = params.author;
    return apiGet<PaginatedResponse<Record<string, unknown>>>(
      buildPaginatedUrl(BASE, params, extraParams)
    );
  },

  getById: (slug: string) => apiGet<{ article: Record<string, unknown> }>(`${BASE}/${slug}`),

  create: (data: Record<string, unknown>) => apiPost<{ article: Record<string, unknown> }>(BASE, data),

  update: (slug: string, data: Record<string, unknown>) =>
    apiPut<{ article: Record<string, unknown> }>(`${BASE}/${slug}`, data),

  delete: (slug: string) => apiDelete<{ message: string }>(`${BASE}/${slug}`),

  getRelated: (slug: string) => apiGet<{ articles: Record<string, unknown>[] }>(`${BASE}/${slug}/related`),
};